import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_CONSULTANT_TIME_SHEET, PATH_CONSULTANT_TIME_SHEET_CONTRACTOR_COMMISSION } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const consultantTimeSheet = {
  namespaced: true,
  state: buildInitialState({
    consultantTimeSheetEntries: [],
    contractorCommission: 0
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setTimeSheetEntries: (state, timeSheetEntries) => {
      state.consultantTimeSheetEntries = timeSheetEntries
    },
    setContractorCommission: (state, contractorCommission) => {
      state.contractorCommission = contractorCommission ? contractorCommission.commission : 0
    }
  },
  actions: {
    getTimeSheetEntries: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time, please wait...' })

      return api.doGet({ path: PATH_CONSULTANT_TIME_SHEET, parameters: filters })
        .then(json => json.data)
        .then(timeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTimeSheetEntries', timeSheetEntries)
          return timeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getContractorCommission: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting contractor commission, please wait...' })

      return api.doGet({ path: PATH_CONSULTANT_TIME_SHEET_CONTRACTOR_COMMISSION, parameters: filters })
        .then(json => json.data)
        .then(contractorCommission => {
          commit('updateStatus', { status: COMPLETE })
          commit('setContractorCommission', contractorCommission)
          return contractorCommission
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get contractor commission. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveTimeSheetEntries: ({ commit, dispatch }, payLoad) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving time, please wait...' })
      return api.doPost({ path: PATH_CONSULTANT_TIME_SHEET, data: payLoad })
        .then(json => json.data)
        .then(timeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          if (!timeSheetEntries) {
            throw new Error('Unable to save time. Try again later')
          }
          notifySuccess(dispatch, 'Time saved')
          return timeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, error.message || 'Unable to save time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default consultantTimeSheet
